<template>
  <div>
    <v-card :color="ui.bkgdColor" dark>
      <v-card-text :class="ui.textSubheading">
        <div>
          <span :class="ui.textSubheadingBold">
            {{getDetail.basic.title}}
          </span>
          <br>
          <span :class="ui.textSubheading">
            {{getDetail.basic.tag}}
            | {{this.defineIDGToString(this.getDetail.basic.idg)}}
            | Revs: {{getDetail.stats.nrev}}
          </span>
          <br>
          <span :class="ui.textSubheading">
            Type: {{getDetail.rev.docType}}
            | Status: {{getDetail.rev.docStatus}}
            | Security: {{getDetail.rev.docSecure}}
          </span>
          <br>
          <span :class="ui.textDescription">
            Review past changes completed by users or machines.
          </span>
        </div>
      </v-card-text>
      <v-card-text :class="ui.textSubheading">
        <div v-for="item in list" :key="item.idg">
          <div v-if="item.idi > 0">
            <v-layout row :class="ui.textSubheadingBold">
              {{item.idi}} Rev {{docRevr2_r3_r4_r5(item)}} - {{docRevModDisplay(item.mod)}}
            </v-layout>
            <v-layout row :class="ui.textSubheading" v-if="item.idi > 0">
              <div class="ml-3 mt-2">
                <DisplayUserTimeInfo :data="{tag: 'D1', item: item}"/>
              </div>
            </v-layout>
            <v-layout row v-if="item.idi > 0">
              <v-spacer/>
              <RevisionReadCard :data="item"/>
            </v-layout>
            <v-progress-linear :color="ui.btnColor" height="2" value="0" v-if="item.idi > 1"/>
          </div>
        </div>
      </v-card-text>
    </v-card>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import docTagFunctions from "@/document/revisions/mixins/docTagFunctions";
import DisplayUserTimeInfo from "@/frame/display/components/DisplayUserTimeInfo";
import RevisionReadCard from "@/document/revisions/components/RevisionReadCard";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";

export default {
  components: {
    DisplayUserTimeInfo,
    RevisionReadCard
  },
  // eslint-disable-next-line
  mixins: [
    dateFunctions,
    apptheme,
    docTagFunctions,
    numberFunctions,
    revFunctions
  ],
  data() {
    return {
      valid: true
    };
  },
  computed: {
    ...mapGetters(["getDocumentRevsList", "getDetail"]),
    list() {
      return this.getDocumentRevsList;
    },
    listTitle() {
      let temp = [];
      let list = this.list;
      for (var i = 0; i < list.length; i++) {
        temp.push(list[i].new.basic.title);
      }
      return temp;
    }
  }
};
</script>
